var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbunlike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#18a7fc",
    height: "800px",
    width: "800px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    stroke: "#18a7fc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7,14.3c-0.3-0.4-0.9-0.6-1.5-0.6h-6.8c-0.7,0-1.3-0.6-1.3-1.3V3.9C20.1,2.8,19,2,18,2c-1,0-1.8,0.8-1.8,1.9 c0,2.3-0.7,4.6-2.1,6.5L11,13.9v11.7c1.7,1.5,4.3,2.4,6.8,2.4h8.5c0.9,0,1.6-0.6,1.8-1.5l2-11.1C30,14.9,30,14.5,29.7,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,15H4.2c-0.7,0-1.3,0.6-1.3,1.3v10.4c0,0.7,0.6,1.3,1.3,1.3h2.6c0.7,0,1.3-0.6,1.3-1.3V16.3C8.1,15.6,7.5,15,6.8,15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbunlike);
export default __webpack_public_path__ + "static/media/fbunlike.aac43835f610dc1f715e23f43af453f2.svg";
export { ForwardRef as ReactComponent };